import { render, staticRenderFns } from "./ClinicianPatientInformation.vue?vue&type=template&id=7bc8f20a"
import script from "./ClinicianPatientInformation.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports